import { Autocomplete, Box, TextField, Typography, Button, FormHelperText } from '@mui/material'
import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Modal } from '../Modal'
import { AccountBalanceWallet, Save } from '@mui/icons-material'
import { useGetTokenizedCardList } from '../../../services/tokenized-card/useTokenizedCard';
import { useTopUpByUser } from '../../../services/user/useUser'
import { useQueryClient } from 'react-query'

interface FormData {
    bankcard: { label: string; id: string } | null;
    description: string;
    amount: string;
}

export default function TopUpModal({ open, onClose, userId }: { open: boolean, onClose: () => void, userId: string }) {
    const queryClient = useQueryClient();
    // const { data: tokenizedCardList } = useGetTokenizedCardList(userId, 1, { per_page: 100 });

    // const bankcards: { label: string, id: string }[] = tokenizedCardList?.data?.map((card: any) => ({
    //   label: `**** **** **** ${card.number} - ${card.expiry_date}`,
    //   id: card._id
    // })) || [];

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset
    } = useForm<FormData>({
        defaultValues: {
            // bankcard: null,
            description: '',
            amount: ''
        }
    });

    const { mutateAsync: topUp, isLoading: isTopUpLoading } = useTopUpByUser();

    const handleAmountBlur = (value: string) => {
        if (value && !isNaN(parseFloat(value))) {
            const formattedAmount = parseFloat(value).toFixed(2);
            setValue('amount', formattedAmount);
        }
    };

    const onSubmit = async (data: FormData) => {
        const topUpResult = await topUp({
            user_id: userId,
            // card_id: data.bankcard?.id,
            description: data.description,
            amount: parseFloat(data.amount),
        });
        if (!topUpResult.ok) {
            return;
        }
        handleClose();
        queryClient.invalidateQueries(['userDetail', userId]);
        queryClient.invalidateQueries(['list_transaction']);
    };

    const handleClose = () => {
        reset();
        onClose();
    };
    const handleReset = () => {
        reset();
    };

    return (
        <Modal open={open} onClose={handleClose} name="Top Up" description='Adjust pricing strategies to optimize revenue' icon={<AccountBalanceWallet fontSize="large" style={{ color: "yellow" }} />}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
                    {/* <Box display={"flex"} flexDirection="column" gap={1}>
                        <Typography>Charge point</Typography>
                        <Controller
                        name="bankcard"
                        control={control}
                        rules={{
                            required: "Please select a bankcard"
                        }}
                        render={({ field }) => (
                            <Autocomplete
                            {...field}
                            options={bankcards}
                            getOptionLabel={(option) => option?.label || ''}
                            onChange={(_, value) => field.onChange(value)}
                            renderInput={(params) => (
                                <>
                                <TextField
                                    {...params}
                                    placeholder="Bankcard"
                                    error={!!errors.bankcard}
                                />
                                <FormHelperText error={!!errors.bankcard}>{errors.bankcard?.message}</FormHelperText>
                                </>
                            )}
                            fullWidth
                            />
                        )}
                        />
                    </Box> */}

                    <Box display={"flex"} flexDirection="column" gap={1}>
                        <Typography>Top up reason</Typography>
                        <Controller
                            name="description"
                            control={control}
                            rules={{
                                required: "Please enter a reason",
                                minLength: {
                                    value: 3,
                                    message: "Reason must be at least 3 characters"
                                }
                            }}
                            render={({ field }) => (
                                <>
                                    <TextField
                                        {...field}
                                        placeholder="Enter reason"
                                        fullWidth
                                        type='text'
                                        error={!!errors.description}
                                    />
                                    <FormHelperText error={!!errors.description}>{errors.description?.message}</FormHelperText>
                                </>
                            )}
                        />
                    </Box>

                    <Box display={"flex"} flexDirection="column" gap={1}>
                        <Typography>Amount</Typography>
                        <Controller
                            name="amount"
                            control={control}
                            rules={{
                                required: "Please enter an amount",
                                validate: {
                                    isNumber: (value) => !isNaN(parseFloat(value)) || "Please enter a valid number",
                                    isPositive: (value) => parseFloat(value) > 0 || "Amount must be greater than 0",
                                }
                            }}
                            render={({ field }) => (
                                <>
                                    <TextField
                                        {...field}
                                        placeholder="Enter amount"
                                        fullWidth
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                                                field.onChange(value);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            handleAmountBlur(e.target.value);
                                            field.onBlur();
                                        }}
                                        inputProps={{
                                            inputMode: 'decimal',
                                            pattern: '[0-9]*[.,]?[0-9]*'
                                        }}
                                        InputProps={{
                                            endAdornment: <Typography sx={{ mr: 1 }}>S$</Typography>
                                        }}
                                        error={!!errors.amount}
                                    />
                                    <FormHelperText error={!!errors.amount}>{errors.amount?.message}</FormHelperText>
                                </>
                            )}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-around', mt: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            startIcon={<Save />}
                            disabled={isTopUpLoading}
                        >
                            Save change
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleReset}
                            fullWidth
                            disabled={isTopUpLoading}
                        >
                            Reset
                        </Button>
                    </Box>
                </Box>
            </form>
        </Modal>
    )
}
